import { FormState } from './types';
import { Resolver } from 'react-hook-form';
import { l10n } from '@ott/l10n';
import differenceInDays from 'date-fns/differenceInDays';
import { MAX_DAYS_INTERVAL } from './constants';
import getMinMaxDates from './utilities/getMinMaxDates';

interface Options {
  skippedFields: string[];
}

const defaultOptions: Options = {
  skippedFields: [],
};

const getResolver =
  (options: Partial<Options> = {}): Resolver<FormState> =>
  (values) => {
    const { skippedFields } = { ...defaultOptions, ...options };
    const errors: Record<string, string> = {};

    const {
      dates: { startDate, endDate },
      to,
    } = values;

    if (!skippedFields.includes('dates')) {
      if (!startDate || !endDate) {
        errors.dates = l10n('hotelsSearchForm.validate.endDate');
      } else {
        if (differenceInDays(startDate, endDate) === 0) {
          errors.dates = l10n('hotelsSearchForm.validate.sameDates');
        }

        if (differenceInDays(endDate, startDate) > MAX_DAYS_INTERVAL) {
          errors.dates = l10n('hotelsSearchForm.validate.intervalDates');
        }

        if (to) {
          const { timezone_gmt: gmt } = to;
          const { minDate, maxDate } = getMinMaxDates(gmt);

          if (
            differenceInDays(startDate, minDate) <= -1 ||
            differenceInDays(maxDate, endDate) <= -1
          ) {
            errors.dates = l10n('hotelsSearchForm.validate.availableDates');
          }
        }
      }
    }

    if (!skippedFields.includes('to')) {
      if (!to) {
        errors.to = l10n('hotelsSearchForm.validate.direction');
      }
    }

    return {
      values,
      errors,
    };
  };

export default getResolver;
